(function ($) {
  $(function () {
    var $productTemplateSection = $(".product-template-section");
    var $productForm = $(".product_form");

    if ($productTemplateSection.length && $productForm.length) {
      var $productName = $productTemplateSection.find("h1.product_name");
      var $currentPrice = $productTemplateSection.find(".current_price");

      var $variantOptions = $productForm.find(".select"); // Variant options ("Select Finish Option", "Railing Option", etc.).

      var $addToCartButton = $productForm.find('button[type="submit"]');

      if (
        $currentPrice.length &&
        $variantOptions.length &&
        $addToCartButton.length
      ) {
        var $fixedName = $('<div class="fixed-details__name"></div>').text(
          $productName.text()
        );

        var $fixedOptions = $('<div class="fixed-details__options"></div>');

        var updateFixedOptions = function () {
          var labels = $variantOptions
            .find("select[data-option] option:selected")
            .map(function () {
              return $(this).text().trim();
            })
            .get();

          $fixedOptions.text(labels.join(", "));
        };

        $productForm.on("change", "select", updateFixedOptions);

        updateFixedOptions();

        var $fixedEdit = $(
          '<span class="fixed-details__edit"><span class="bracket">(</span><a role="button" tabindex="0">Edit</a><span class="bracket">)</span></span>'
        );

        var getHeaderHeight = function () {
          var $visibleHeaderElements = $("#shopify-section-header")
            .children()
            .add($(".mobile-header"))
            .filter(":visible");

          if (!$visibleHeaderElements.length) return 0;

          var height = 0;

          $visibleHeaderElements.each(function (index, element) {
            height += element.offsetHeight;
          });

          return height;
        };

        var $scrollable = $("html, body");

        $fixedEdit.on("click", "a", function (e) {
          $scrollable.scrollTop($productName.offset().top - getHeaderHeight());
        });

        var $fixedSummary = $('<div class="fixed-details__summary"></div>');

        $fixedSummary.html([$fixedOptions, " ", $fixedEdit]);

        var $fixedDetails = $('<div class="fixed-details"></div>')
          .append($fixedName)
          .append($fixedSummary);

        $fixedDetails.insertAfter($variantOptions);

        var $addToCartButtonPrice = $(
          '<span class="price">' + $currentPrice.text() + "</span>"
        ).css("display", "none");

        var updateAddToCartButtonPrice = function () {
          $addToCartButtonPrice.text(" – " + $currentPrice.text());
        };

        updateAddToCartButtonPrice();

        $addToCartButton.append($addToCartButtonPrice);

        var priceObserver = new MutationObserver(function (
          mutationList,
          observer
        ) {
          updateAddToCartButtonPrice();
        });

        priceObserver.observe($currentPrice[0], {
          attributes: true,
          childList: true,
          subtree: true,
        });
      }

      var isMobile = function () {
        return window.matchMedia("(max-width: 991px)").matches;
      };

      var isDesktop = function () {
        return window.matchMedia("(min-width: 992px)").matches;
      };

      var floatingClass = "product_form--fixed-bottom";

      var removeFloatingClass = function () {
        $productForm.removeClass(floatingClass);
      };

      var maybeAddFloatingClass = function () {
        if (
          (floatingProductForm.enableForDesktop && isDesktop()) ||
          (floatingProductForm.enableForMobile && isMobile())
        ) {
          $productForm.addClass(floatingClass);
        } else {
          removeFloatingClass();
        }
      };

      maybeAddFloatingClass();

      var floatingObserver = new IntersectionObserver(
        ([entry]) => {
          entry.isIntersecting
            ? removeFloatingClass()
            : maybeAddFloatingClass();
        },
        { root: null, threshold: 0 }
      );

      floatingObserver.observe($productForm[0]);
    }
  });
})(jQuery);
